var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgZoomOut = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 16 16",
    fill: "none",
    className: "mdl-js",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1.00752C16 1.00501 16 1.00251 16 1C16 0.447716 15.5523 0 15 0H15H11C10.4477 0 10 0.447715 10 1C10 1.55228 10.4477 2 11 2H12.6009L9.35736 5.24349C8.96684 5.63402 8.96684 6.26718 9.35736 6.65771C9.74789 7.04823 10.3811 7.04823 10.7716 6.65771L14 3.4293V5C14 5.55228 14.4477 6 15 6C15.5523 6 16 5.55228 16 5V1.00752Z",
    fill: "#d6d6d6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.42845 10.1724L2 12.6008L2 11C2 10.4477 1.55229 10 1 10C0.447719 10 3.34642e-06 10.4477 3.29814e-06 11L2.94845e-06 15C2.90016e-06 15.5523 0.447718 16 1 16L5.00001 16C5.55229 16 6.00001 15.5523 6.00001 15C6.00001 14.4477 5.55229 14 5.00001 14L3.42925 14L5.84267 11.5866C6.23319 11.1961 6.23319 10.5629 5.84267 10.1724C5.45214 9.78185 4.81898 9.78185 4.42845 10.1724Z",
    fill: "#d6d6d6"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgZoomOut, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/zoomOut.f2a71536.svg";
export { ForwardRef as ReactComponent };